import { environment } from './../../environments/environment';
export class AppAPIConfig {
  // private baseURL="";

  //private baseURL="http://3.1.42.248";

  //private baseURL = "http://3.1.42.248/ediaryApiTest";
  //private baseURL="http://3.1.42.248/ediaryApi";
  //private baseURL="http://3.108.121.253/ediaryApi";
  private baseURL = environment.apiUrl;
  //private baseURL=environment.apiUrl;
  //private baseURL="/ediaryApi";
  // private baseURL="/ediaryApiTest";

  // User
  public loginAPI = this.baseURL + '/users/login';
  public logoutAPI = this.baseURL + '/users/logout';
  public getUsersAPI = this.baseURL + '/users';
  public getClientsAPI = this.baseURL + '/client';
  public getLocationsAPI = this.baseURL + '/location';
  public getAssignmentsAPI = this.baseURL + '/assignment';
  public getTasksAPI = this.baseURL + '/task';
  public getDiaryAPI = this.baseURL + '/diary/user'; // '/{id}'
  public deleteDiaryStatus= this.baseURL + '/diary/deleteWeekStatus';
  public getCurrentAndLastfinancialYear = this.baseURL + '/financialyear/current-and-last';

  //Client Billing
  public clientByBranchAPI = this.baseURL + '/client'; // '/{id}'
  public assignmentByClientAPI = this.baseURL + '/assignment';
  public clientBillingReportAPI = this.baseURL + '/billing';
  public clientBillingReportExcelAPI = this.baseURL + '/excel-export/billing/excel';
  public generateBillAPI = this.baseURL + '/billing';
  public generateClientBillAPI = this.baseURL + '/reports/client/billing/dates';
  public clientConveyanceReportAPI =
    this.baseURL + '/reports/client-conveyance';
  public clientConveyanceReportExportToExcelAPI =
    this.baseURL + '/excel-export/client-conveyance';
  public clientByBilledConveynceReportAPI =
    this.baseURL + '/reports/client-conveyance/by-client';
  public clientByBilledConveynceReportExportToExcelAPI =
    this.baseURL + '/excel-export/client-conveyance/by-client';
  public clientByMonthlyConveyanceReportAPI =
    this.baseURL + '/reports/client-conveyance/by-period';
  public clientByMonthlyConveyanceReportExportToExcelAPI =
    this.baseURL + '/excel-export/client-conveyance/by-period';
  public clientConveyanceAssignmentReportAPI =
    this.baseURL + '/reports/client-assignment-conveyance';
  public clientConveyanceAssignmentReportExportToExcelAPI =
    this.baseURL + '/excel-export/client-assignment-conveyance';
  public clientByBilledConveynceAssignmentReportAPI =
    this.baseURL + '/reports/client-assignment-conveyance/by-assignment';
  public clientByBilledConveynceAssignmentExportToExcelReportAPI =
    this.baseURL + '/excel-export/client-assignment-conveyance/by-assignment';
  public clientByMonthlyConveyanceAssignmentReportAPI =
    this.baseURL + '/reports/client-assignment-conveyance/by-period';
  public clientByMonthlyConveyanceAssignmentExportToExcelReportAPI =
    this.baseURL + '/excel-export/client-assignment-conveyance/by-period';


  //Independence Declaration
  saveIndependenceDeclerationAPI = this.baseURL + '/declaration';
  declerationPendingApi =
    this.baseURL + '/declaration/user/pending/declarations';
  declerationApi = this.baseURL + '/declaration';
  getIndependenceDeclerationMailAPI = this.baseURL + '/declaration/user';
  getAllActiveClientList = this.baseURL + '/client/active';
  //Document
  // public documentUploadAPI = this.baseURL + '/users/docsList';
  public documentUploadListAPI = this.baseURL + '/users/docs';
  // Diary
  public diaryAPI = this.baseURL + '/diary';
  // Assignment
  public assignmentAPI = this.baseURL + '/assignment';
  // Tasks
  public taskAPI = this.baseURL + '/task';
  // Branch
  public branchAPI = this.baseURL + '/branch';
  // Financial Year
  public financialYearAPI = this.baseURL + '/financialyear';
  public clientBudgetForYearAPI = this.baseURL + '/client/budget';
  // Role
  public roleAPI = this.baseURL + '/role';

  // Designation
  public designationAPI = this.baseURL + '/designation';
  // Location
  public locationAPI = this.baseURL + '/location';
  // sector
  public sectorAPI = this.baseURL + '/sector';
  // ediaryStatus
  public ediaryStatusAPI = this.baseURL + '/lookup/ediarystatus';
  // legalStatus
  public legalStatusAPI = this.baseURL + '/lookup/legalstatus';
  // State
  public stateAPI = this.baseURL + '/lookup/state';
  // Cities
  public cityAPI = this.baseURL + '/lookup/city';
  // Postcode
  public postcodeAPI = this.baseURL + '/lookup/postcode';
  // Check List
  public checklistAPI = this.baseURL + '/checklist';
  // Client
  public clientAPI = this.baseURL + '/client';
  // Conveyance
  public conveyanceAPI = this.baseURL + '/conveyance';
  // Standardrate
  public standardrateAPI = this.baseURL + '/standardrate';
  // Branch Holiday
  public branchHolidayAPI = this.baseURL + '/branch/fy-holiday';
  public createUpdateBranchHolidayAPI = this.baseURL + '/branch/holiday';
  // Branch Holiday
  public articleStipendAPI = this.baseURL + '/articlestipend';
  public getArticleStipendAPI = this.baseURL + '/articlestipend/by-year';
  // Company Configuration
  public companysetupAPI = this.baseURL + '/companysetup';
  // User
  public userAPI = this.baseURL + '/users';
  public profileAPI = this.baseURL + '/users';
  public employeeProfileAPI = this.baseURL + '/users/profile';
  public manageProfileAPI = this.baseURL + '/users/manage-profile';
  public overtimeApplicabilityAPI = this.baseURL + '/lookup/overtime-applicability-status';
  // public userMenuAPI = this.baseURL + '/users/menu'; 
  public userMenuAPI = this.baseURL + '/role-menu-submenu-accesses';
  public allMenusAPI = this.baseURL + '/menu-submenu';
  public accessControlAPI = this.baseURL + '/role-menu-submenu-accesses';
  public folderAPI = this.baseURL + '/folder'; // Users
  public singleDocumentAPI = this.baseURL + '/folder/document';
  public singleViewOnlyDocumentAPI = this.baseURL + '/folder/document/updateView';
  public deleteDocumentUrlAPI = this.baseURL + '/folder/url';
  public singleDocumentUrlAPI = this.baseURL + '/folder/upload-url';

  public getFolderDocumentsAPI = this.baseURL + '/folder/documents';

  public userPartnerAPI = this.baseURL + '/users/partner';
  public userPartnerOfBranchAPI = this.baseURL + '/users/partners';
  public userOfPartnerAPI = this.baseURL + '/users/reporting-partner';
  public multiplePartnerAnnualStipend=this.baseURL +'/reports/anual-stipend';
  public articlesByReportingPartner=this.baseURL+ '/users/articles-by-reporting-partner'; 
  public userByProfile = this.baseURL + '/users/profile';
  public userByReportingPartnerAPI = this.baseURL + '/users/latest-employees-for-partner';
  public myHolidayReportAPI = this.baseURL + '/financialyear/holidays';

  // Weeks
  public weeksForFyAPI = this.baseURL + '/diary/week/user';
  public approversAPI = this.baseURL + '/users/approver';
  public getDiaryActiveClientsAPI = this.baseURL + '/client/active';
  public diaryClientAPI = this.baseURL + '/diary/client';
  public clientAssignmentAPI = this.baseURL + '/diary/client';
  public assignmentTaskAPI = this.baseURL + '/diary/client';

  // Diary Submission
  public submitDiaryAPI = this.baseURL + '/diary/user/submit/date';
  public submitAllDiariesAPI = this.baseURL + '/diary/user/submit';
  public pendingSumissionWeeksForFyAPI =
    this.baseURL + '/diary/week/submission/user';
  public checkBudgetExistOrNotAPI = this.baseURL + '/diary/check-date';

  // Diary Approvals
  public pendingDiaryApprovalsAPI = this.baseURL + '/diary/week/approval';
  public approveDiaryAPI = this.baseURL + '/diary/user/approve';
  public resendDiaryAPI = this.baseURL + '/diary/user/resend';
  public approveAllDiaryAPI = this.baseURL + '/diary/user/approve';
  public unapproveDiaryAPI = this.baseURL + '/diary/unapproved';
  public pendingDiaryWeeksForTeamAPI = this.baseURL + '/reports/pendingDiaryWeeksForTeam';
  public exportPendingDiaryWeeksForTeamToExcelAPI = this.baseURL + '/jasper-export/pendingDiaryWeeksForTeam';

  // Leave Approvals
  public leaveAPI = this.baseURL + '/leave';
  public leaveSummaryAPI = this.baseURL + '/leave/summary';
  public appliedLeavesAPI = this.baseURL + '/leave/all-applied';
  public appliedLeavesForMyLeavesAPI = this.baseURL + '/leave/applied';
  public pendingLeavesAPI = this.baseURL + '/leave/pending';
  public changeLeaveStatusAPI = this.baseURL + '/leave/status';
  public balanceLeaveAPI = this.baseURL + '/leave/balance';

  // Leave Type
  public leaveTypeAPI = this.baseURL + '/lookup/leavetype';

  // Certifications
  public certificationAPI = this.baseURL + '/lookup/certification';
  public qualificationAPI = this.baseURL + '/qualifications';

  // Service Vertical
  public serviceVerticalAPI = this.baseURL + '/service-vertical';
  public userByRoleAndServiceVerticalAPI = this.baseURL + '/reports/userByRoleAndServiceVertical';
  public usersByserviceVerticalAndRoleAPI = this.baseURL + '/reports/userByRoleBranchServiceVertical';
  public userByRoleServiceVerticalAPI = this.baseURL + '/reports/userByRoleServiceVertical';

  // Budget
  public budgetAPI = this.baseURL + '/budget';
  public budgetManDaysAPI = this.baseURL + '/budget/fy-man-days';

  // Hr reports
  public getDiaryReportsAPI = this.baseURL + '/reports';
  public getDiaryReportsExportToExcelAPI = this.baseURL + '/excel-export';
  public overTimeReportsAPI = this.baseURL + '/reports/over-time';
  public overTimeReportsExcelAPI = this.baseURL + '/excel-export/overTime';
  public articleAvailabilityReportAPI = this.baseURL + '/reports/article-availability';
  public articleAvailabilityExportToExcelAPI = this.baseURL + '/excel-export/article-availability-report';
  public articleTenureAPI=this.baseURL+'/reports/articleshipTenure';
  public partnerByBranchAPI = this.baseURL + '/users/partners';
  public monthlyNewJoineeReportAPI=this.baseURL +'/reports/monthlyJoinee';
  public monthlyLeftEmployeeReportAPI=this.baseURL +'/reports/monthlyExit';
  public monthlyNewJoineeExcelAPI = this.baseURL + '/excel-export/monthlyJoineeExcel';
  public monthlyLeftEmployeeExcelAPI = this.baseURL + '/excel-export/monthlyExitExcel';
  public getDiaryReportsClientWiseExportToExcelAPI = this.baseURL + '/excel-export/clientAndAssignment';
  public getCommitmentLetterForArticleAPI = this.baseURL + '/jasper-export/article/commitment-letter';
  public getContractLetterForEmployeeAPI = this.baseURL + '/jasper-export/employee/contract';
  public probationCompleteDetailsAPI = this.baseURL + '/reports/probationDetails';
  public articleshipEndAPI = this.baseURL + '/reports/articleshipEndDetails';
  public consultantsEndAPI = this.baseURL + '/reports/consultantEndDetails';
  public workAnniversaryReportAPI = this.baseURL + '/reports/workAnniversaryDetails';
  public incompleteProfilesReportAPI = this.baseURL + '/reports/incomplete-profiles';
  public incompleteProfilesReportExportToExcelAPI = this.baseURL + '/excel-export/incomplete-profiles';
  public latestCtcDetailsReportAPI = this.baseURL + '/reports/latest-ctc-details-report';
  public latestCtcDetailsReportExportToExcelAPI = this.baseURL + '/excel-export/latest-ctc-details-report';
  public latestReportingPartnersReportAPI = this.baseURL + '/reports/latest-reporting-partners-report';
  public latestReportingPartnersReportExportToExcelAPI = this.baseURL + '/excel-export/latest-reporting-partners-report';
  //standard Report
  public userByDateAPI = this.baseURL + '/reports/diary-clients';

  // Account Reports
  public salaryReportAPI = this.baseURL + '/reports/employee/salary';
  // public salaryReportExportToExcelAPI = this.baseURL + '/reports/employee/salary/excel';
  public salaryReportExportToExcelAPI = this.baseURL + '/excel-export/employee/salary/excel';
  public stipendReportAPI = this.baseURL + '/reports/article/stipend';
  public stipendReportExportToExcelAPI = this.baseURL + '/reports/article/stipend/excel';
  public monthlyConveyanceReportAPI = this.baseURL + '/reports/monthly-conveyance';
  public monthlyConveyanceDetailReportAPI = this.baseURL + '/reports/monthly-conveyance-details';
  public monthlyConveyanceDetailReportExportToExcelAPI = this.baseURL + '/excel-export/monthly-conveyance-details';
  public daywiseConveyanceDetailReportAPI = this.baseURL + '/reports/daywise-details';
  public daywiseConveyanceReportExportToExcelAPI = this.baseURL + '/excel-export/daywise-details';
  //
  public closingDateAPI = this.baseURL + '/reports/closingDates';

  // Leave Employee Leave Summary
  public employeeLeaveSummaryAPI = this.baseURL + '/reports/employee/leave';
  public leaveSummaryExportToExcelAPI = this.baseURL + '/excel-export/employee/leave/excel';
  public penaltySummaryAPI = this.baseURL + '/reports/penalty';
  public penaltySummaryExportToExcelAPI = this.baseURL + '/excel-export/penalty';
  public approvalPenaltyDetailAPI = this.baseURL + '/reports/diary-approval-penalty';
  public approvalPenaltyExcelToExportAPI = this.baseURL + '/excel-export/diary-approval-penalty';
  public submissionPenaltyDetailAPI = this.baseURL + '/reports/diary-submission-penalty';
  public submissionPenaltyExcelToExportAPI = this.baseURL + '/excel-export/diary-submission-penalty';
  public lateLeaveApplicationPenaltyDetailAPI = this.baseURL + '/reports/leave-application-penalty';
  public lateLeaveApplicationPenaltyExcelToExportAPI = this.baseURL + '/excel-export/leave-application-penalty';
  public lateLeaveApprovalPenaltyDetailAPI = this.baseURL + '/reports/leave-approval-penalty';
  public lateLeaveApprovalPenaltyExcelToExportAPI = this.baseURL + '/excel-export/leave-approval-penalty';

  //Analytic Report
  public annualIndependenceAPI = this.baseURL + '/reports/anual/independence';
  public annualIndependenceExcelAPI = this.baseURL + '/excel-export/anual/independence/excel';
  public clientIndependenceAPI = this.baseURL + '/reports/client/independance';
  public clientIndependenceExcelAPI = this.baseURL + '/excel-export/client/independence/excel';
  public employeeIndependenceAPI =this.baseURL + '/reports/employee/independence';
  public employeeJoiningDeclarationExcelAPI =this.baseURL + '/excel-export/employee/independence/excel';
  public allClientIndependenceAPI =this.baseURL + '/reports/all/clients/independence';
  public allClientIndependenceExcelAPI =this.baseURL + '/excel-export/all/clients/independence/excel';
  public dpdpIndependenceAPI =this.baseURL + '/reports/dataProrection/independence';
  public clientEmployeeAPI = this.baseURL + '/reports/client/list';
  public budgetReportAPI = this.baseURL + '/reports/budget';
  public budgetReportExcelToExportOldAPI = this.baseURL + '/excel-export/budget/old';
  public budgetReportExcelToExportNewAPI = this.baseURL + '/excel-export/budget';

  public getIndividualLeaveReportAPI = this.baseURL + '/reports/myLeaves/';

  public oneSixthReportAPI = this.baseURL + '/reports/article-one-sixth';
  public oneSixthReportExcelAPI = this.baseURL + '/excel-export/article-onesixth-report';

  //Announcement
  public createAnnouncementAPI = this.baseURL + '/announcement/add';
  public creatAnnouncementImageAPI = this.baseURL + '/announcement/upload';
  public getAnnouncementAPI = this.baseURL + '/announcement';
  public updateAnnouncementAPI = this.baseURL + '/announcement';
  public updateAnnouncementImageAPI = this.baseURL + '/announcement/upload';
  public deleteAnnouncementAPI = this.baseURL + '/announcement';
  public getAnnouncementHistoryAPI = this.baseURL + '/announcement/history';

  //empanelment
  public empanelmentRoleAPI = this.baseURL + '/reports/empanelement-roles';
  public empanelmentReportAPI = this.baseURL + '/reports/empanelement';

  //Change Password
  public changePasswordAPI = this.baseURL + '/users/change-password';
  public forgotPasswordAPI = this.baseURL + '/users/forgot-password';

  //Travel Sheet
  public travelSheetAPI = this.baseURL + '/tsheet';
  public travelSheetLeaveCheckAPI = this.baseURL + '/leave';
  public submittedSheetsExportToExcelAPI = this.baseURL + '/excel-export/submitted-sheets';

  //budget VS actual cost
  public getAllBudgetedPartnerAPI = this.baseURL + '/users/budgeted-partners';
  public getClientsByYearAPI = this.baseURL + '/client/by-budgets';
  public getClientsByYearAndBudgetAPI = this.baseURL + '/client/budgeted';
  public getClientsByPartnerAPI = this.baseURL + '/client/partner';
  public budgetVSActualCostForFYAPI = this.baseURL + '/reports/actual-Vs-Budgeted';
  public budgetVSActualCostForPartnerAPI = this.baseURL + '/reports/actual-Vs-Budgeted-by-partner';
  public budgetVSActualCostForFYByDesignationAPI = this.baseURL + '/reports/actual-Vs-Budgeted-by-designation';
  public budgetVSActualCostForClientAPI = this.baseURL + '/reports/actual-Vs-Budgeted-by-clients';
  public budgetVSActualCostForAssignmentAPI = this.baseURL + '/reports/actual-Vs-Budgeted-by-assignments';

  //bank statement
  public bankPaymentAPI = this.baseURL + '/reports/bank-statement';
  // public bankPaymentExportToExcelAPI = this.baseURL + '/excel-export/bank-statement';
  public bankPaymentExportToExcelAPI = this.baseURL + '/jasper-export/bank-statement';

  //client Excel
  public clientExportToExcelAPI = this.baseURL + '/excel-export/client-master';

  //annual salary report
  public annualSalaryReportAPI = this.baseURL + '/reports/anual-salary';
  public annualSalaryReportExcelAPI = this.baseURL + '/excel-export/anual-salary';

  //salary slip
  public employeeByBranchAPI = this.baseURL + '/users/branchwise';
  public salarySlipReportAPI = this.baseURL + '/reports/salary-splip';
  public salarySlipReportExportToExcelAPI = this.baseURL + '/excel-export/salary-splip';

  //article debit credit report
  public articleListByBranchAPI = this.baseURL + '/users/article';
  public debitCreditHoursAPI = this.baseURL + '/reports/article/Debit-Credit';
  public debitCreditHoursExportToExcelAPI = this.baseURL + '/excel-export/article/Debit-Credit';

  //Exit Form
  public saveExitFormAPI = this.baseURL + '/users/exit-form';
  public exitFormSummaryAPI = this.baseURL + '/users/exit-forms';
  public userExitFormAPI = this.baseURL + '/users/exit-form';
  // public updateExitFormAPI = this.baseURL + '/users/exit-form';

  //annual stipend report
  public annualStipendReportAPI = this.baseURL + '/reports/anual-stipend';
  public annualStipendReportExcelAPI = this.baseURL + '/excel-export/anual-stipend';

  //reimbursement report
  public reimbursementReportAPI = this.baseURL + '/reports/expense-reimbursement';
  public reimbursementReportExcelAPI = this.baseURL + '/excel-export/expense-reimbursement';

  //My Atcual Task
  public myActualTaskReportAPI = this.baseURL + '/reports/actual-task-summary';
  public clientsByEmpAndStatusAPI = this.baseURL + '/client/employee-clients';
  public clientsByEmp = this.baseURL + '/client/partner-clients';
  public myActualTaskExcelAPI = this.baseURL + '/excel-export/actual-task-summary';
  public branchByEmployeeAPI = this.baseURL + '/users/by-id';
  public assignmentsByClientsAPI = this.baseURL + '/diary/assignments';
  public clientByEmployeeAPI = this.baseURL + '/diary/clients';

  //Assets Management 
  public getTypeListAssetsManagementAPI = this.baseURL + '/asset/list';
  public saveSoftwareAssetAPI = this.baseURL + '/asset/add-software';
  public updateSoftwareAssetAPI = this.baseURL + '/asset/update';
  public getListAssetsManagementAPI = this.baseURL + '/asset/by-status';
  public saveUpdateHardwareAssetAPI = this.baseURL + '/asset';
  public getServiceTagNumberListAPI = this.baseURL + '/asset/by-tag';
  public getHardwareServiceTagNumberAPI = this.baseURL + '/asset/by-type';
  public getHardwareServiceTagNumberForSoftwareAPI = this.baseURL + '/asset/hardwares-for-software ';
  public getUserListAPI = this.baseURL + '/asset/users';
  public executeHardwareTransferAPI = this.baseURL + '/asset/hardware-transfer';
  public executeSoftwareTransferAPI = this.baseURL + '/asset/software-transfer';
  public hardwareTransferRequest = this.baseURL + '/asset/transfer-request';
  public hardwarePendingRequest = this.baseURL + '/asset/pending-request';
  public fromUserPendingRequest = this.baseURL + '/asset/pending-request-fromUser';
  public monthlyConfirmAssetDetailsAPI = this.baseURL + '/asset/monthly-confirmation';
  public physicalVerificationReportAPI = this.baseURL + '/reports/physical-verification';
  public physicalVerificationReportExcelAPI = this.baseURL + '/excel-export/physical-verification';
  public transferSoftwareAPI = this.baseURL + '/reports/software-history';
  public transferHardwareAPI = this.baseURL + '/reports/hardware-history';
  public transferSoftwareExcelAPI = this.baseURL + '/excel-export/software-history';
  public transferHardwareExcelAPI = this.baseURL + '/excel-export/hardware-history';
  public approveTransferRequestAPI = this.baseURL + '/asset/transfer-approval';
  public monthlyConfirmationPopupDetailsAPI = this.baseURL + '/asset/monthly-confirmation';
  public assetConfirmationDetailsReportAPI = this.baseURL + '/reports/asset-confirmation';
  public assetConfirmationDetailsReportExcelAPI = this.baseURL + '/excel-export/asset-confirmation';
  public assetConfirmationDateAPI = this.baseURL + '/asset/confirmation-dates';
  public assetTermsOfUsesAPI = this.baseURL + '/asset/declaration';
  public serviceTagByBranchAPI = this.baseURL + '/asset/by-branch';
  public assetsByBranchStatusExcelAPI = this.baseURL + '/jasper-export/assets/by-status';

  //updateBudgetExcel
  public updateBudgetExcelAPI = this.baseURL + '/budget';
  public varianceReportExcelByPartnerAPI = this.baseURL + '/excel-export/actual-Vs-Budgeted-by-clients';
  public varianceReportExcelByYearAPI = this.baseURL + '/excel-export/actual-Vs-Budgeted-by-partner';
  public varianceSummaryReportAPI=this.baseURL+'/reports/actualVsBudgeted-by-partner';
  public partnerVarianceSummaryReportAPI=this.baseURL+'/reports/actualVsBudgeted-by-clients';
  public varianceSummaryReportByMandaysFirmLevelAPI=this.baseURL+'/reports/mandaysVariance-by-partners';
  public varianceSummaryReportByMandaysPartnerLevelAPI=this.baseURL+'/reports/mandaysVariance-by-clients';
  public varianceSummaryReportMandaysExcelByFirmLevel=this.baseURL+'/jasper-export/excel-mandaysVariance-by-firm'
  public varianceSummaryReportMandaysExcelByPartnerLevel=this.baseURL+'/jasper-export/excel-mandaysVariance-by-clients'
  //Empanelment Excel
  public empanelmentReportExcelAPI = this.baseURL + '/excel-export/empanelement';
  public checkDiaryExistForBudgetAPI = this.baseURL + '/diary/check';

  //dormant client 
  public clientListByBranchStatus = this.baseURL + '/client/status';

  public commonDashboardCountAPI = this.baseURL + '/dashboard/count';
  public hrAdminDashboardCountAPI=this.baseURL+'/dashboard/hrDashboard';
  public partnerDashboardCountAPI=this.baseURL+'/dashboard/partnerDashboard';
  public managingPartnerDashboardAPI=this.baseURL+'/dashboard/managing-partner';

  public articleVacancyAPI=this.baseURL+'/article-vacancy';
  public partnerListAPI=this.baseURL+'/reports/activePartners';

  public myTargetReportAPI=this.baseURL+'/reports/MyTargets';

  //management Information System

  public getMisDetailsAPI=this.baseURL+'/mis/details';
  public saveMisDetails=this.baseURL+'/mis';
  public uploadMisDocuments=this.baseURL+'/mis/upload';
  public submitMisDetails=this.baseURL+'/mis/submit';
  public assignmentByPartner=this.baseURL+'/client/assignment-by-partner';
  public assignmentFeesForClient=this.baseURL+'/reports/assignmentFeesForClient';
  public assignmentFeesForClientForFy=this.baseURL+'/reports/assignmentFeesForClientForFy';
  public misReportDetails=this.baseURL+'/jasper-export/mis';

   // CTC Details Report
  public ctcDetailsReportAPI = this.baseURL + '/reports/employee-ctc-details';
}
